import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { getDDLlist, getConfigData } from '../_redux/actions/configActions';

import ReportDocumentPage from './ReportDocumentPage';

class ReportPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuName: 'reports',
            show_result: true,
        };
    }

    async componentDidMount() {
        if (
            this.props.match.params.menuName !== undefined &&
            this.props.match.params.menuName !== ''
        ) {
            this.setState({ menuName: this.props.match.params.menuName });
        }

        document.body.classList.remove('aside-minimize');
        document.body.classList.remove('doc-small-view');
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.match.params.menuName !==
                this.props.match.params.menuName &&
            this.props.match.params.menuName !== undefined &&
            this.props.match.params.menuName !== ''
        ) {
            // this.setState({ menuName: this.props.match.params.menuName });
        }
    }

    render() {
        return (
            <div className='search-right-aside'>
                {this.state.menuName === 'reports' ? (
                    <ReportDocumentPage
                        calingFrom='search'
                        pageTitle='Report'
                        updateState={(state) => {
                            this.setState({ ...state });
                        }}
                        query={this.state.query}
                        show_result
                    />
                ) : null}
            </div>
        );
    }
}

const mapDispatchToProps = {
    getDDLlist: getDDLlist,
    getConfigData: getConfigData,
};
const mapStateToProps = (state) => {
    return {
        configData: state.configReducerPersist.configData,
    };
};

export default React.memo(
    connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportPage))
);
